export default "__VITE_ASSET__CCXxsq3v__"